import type { ReactNode } from 'react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { Privacidade, Termos } from './Legal.js';
import './styles.css';

/**
 * Roteador do tamanho do problema.
 *
 * Tres paginas estaticas nao justificam uma biblioteca de rotas: seriam uns
 * 10 kB no bundle de uma landing para resolver um `switch`. O servidor ja
 * devolve o `index.html` em qualquer caminho (`try_files ... /index.html`),
 * entao /termos e /privacidade funcionam sem tocar no Nginx.
 *
 * Caminho desconhecido cai na home em vez de tela branca.
 */
const PAGINAS: Record<string, () => ReactNode> = {
  '/termos': Termos,
  '/privacidade': Privacidade,
};

const rota = window.location.pathname.replace(/\/+$/, '') || '/';
const Pagina = PAGINAS[rota] ?? App;

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <Pagina />
  </StrictMode>,
);
